import {useState} from 'react';
import {BasicAnalysisResult} from '@/map/@types';
import {ColumnFlexBox, Flexbox} from '@/styled-components';
import {EmptyBox, SectionContainer, SectionInfoIcon, SectionTitle} from '../StyledComponents';
import {Household} from './Household';
import {InfoWindow} from './InfoWindow';
import {PresumePolulation} from './PresumePopulation';

interface IProps {
  data?: BasicAnalysisResult;
  isPending?: boolean;
  error?: string;
}

export const Populations = ({data, isPending, error}: IProps) => {
  const [openInfo, setOpenInfo] = useState<boolean>(false);

  const toggleInfoWindow = () => setOpenInfo((prev) => !prev);

  if (error?.length) {
    return (
      <SectionContainer>
        <SectionTitle>인구</SectionTitle>
        <EmptyBox>
          <span dangerouslySetInnerHTML={{__html: error}} />
        </EmptyBox>
      </SectionContainer>
    );
  }

  return (
    <div>
      <SectionTitle>
        <Flexbox>
          인구
          <SectionInfoIcon onClick={toggleInfoWindow} />
          {openInfo && <InfoWindow onClose={toggleInfoWindow} />}
        </Flexbox>
      </SectionTitle>
      <ColumnFlexBox gap={8}>
        <SectionContainer>
          <Household data={data} isLoading={isPending} />
        </SectionContainer>
        <SectionContainer>
          <PresumePolulation data={data} isPending={isPending} />
        </SectionContainer>
      </ColumnFlexBox>
    </div>
  );
};
